import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row-top" }
const _hoisted_2 = { class: "col gap-01" }
const _hoisted_3 = { class: "row mtop-02" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "font-m" }
const _hoisted_6 = {
  key: 2,
  class: "mtop-30 colCenter"
}
const _hoisted_7 = {
  key: 3,
  class: "mtop-30 row gap-20"
}

import loadingSpinner from "@/views/loadingSpinner.vue";

import { ref, computed } from 'vue'
import gen from '@/functions/general.js';
import { apiDateString } from '@/api/apicommon';
import officeapi from '@/api/officeapi';
import { useI18n } from 'vue-i18n'

export default /*@__PURE__*/_defineComponent({
  __name: 'editTransaction',
  props: {
  invoice: {
    type: Object,
    required: true,
  },
  transaction: {
    type: Object,
    required: true,
  },
  currChannel: {
    type: Object,
    default: null,
  },  
  allCurrChannels: {
    type: Array,
    default: null,
  },
},
  emits: ['close', 'modifyTxChannel'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit

const dropd = ref();
const currAmount = ref(props.transaction.amount)
const currDate = ref(props.transaction.transactionDateTime)
const isEdited = ref(false)
const isSubmitting = ref(false);

const CHANNEL_GROUPS = {
  directPayment: ["Cash", "BankCard", "DigitalPayment"],
  awaitPayment: ["LuTp", "LuTpSocial"],
  cancelled: ["Cancelled"],
  bankAccount: ["BankAccount"],
};

function getChannelGroup(type: string) {
  return Object.values(CHANNEL_GROUPS).find(group => group.includes(type));
}

const switchableChannels = computed(() => {
  const currentType = props.allCurrChannels.find(
    channel => channel.id === props.transaction.financialChannelId
  )?.type;
  if (!currentType) return [];
  const group = getChannelGroup(currentType);
  if (!group) return [];
  return props.allCurrChannels.filter(
    channel => group.includes(channel.type) && channel.id !== props.transaction.financialChannelId
  );
});

const showChannelSwitch = computed(() => switchableChannels.value.length > 0);

async function deleteTransaction() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    const transactionId = props.transaction.transactionId;
    await officeapi.deleteTransaction(transactionId);
    emits('close');
  } finally {
    isSubmitting.value = false;
  }
}

async function modifyTxChannel(channel) {
  dropd.value = "";
  emits('modifyTxChannel', channel);
}

async function update() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    await updateTransactionAmount();
    await updateTransactionDate();
    emits('close');
  } finally {
    isSubmitting.value = false;
  }
}

function cancel() {
  emits('close')
}

async function updateTransactionAmount() {
  if (props.transaction.isLocked) return;  
  const transactionId = props.transaction.transactionId
  const oldAmount = props.transaction.amount
  const newAmount = currAmount.value
  if (oldAmount === newAmount) return
  await officeapi.updateTransactionAmount(transactionId, newAmount)
}

async function updateTransactionDate() {
  if (props.transaction.isLocked) return;  
  const transactionId = props.transaction.transactionId
  const oldDate = props.transaction.transactionDateTime.slice(0, 10)
  const newDate = currDate.value.slice(0, 10)
  if (oldDate === newDate) return
  await officeapi.updateTransactionDate(transactionId, newDate)
}

function updateActDate(newIso) {
  currDate.value = newIso
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin":"1rem","padding":"1rem","width":"20rem"},
    class: "bg-modal",
    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('accounting.transaction'),
          styles: "font-l"
        }, null, 8, ["txt"]),
        (__props.transaction.isLocked && !showChannelSwitch.value)
          ? (_openBlock(), _createBlock(_component_text_item, {
              key: 0,
              txt: _unref(t)('accounting.editTransaction.locked'),
              styles: "font-m",
              class: "mtop-04"
            }, null, 8, ["txt"]))
          : _createCommentVNode("", true)
      ]),
      (!__props.transaction.isLocked && !isSubmitting.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            style: {"margin-left":"auto","margin-top":"-0.4rem"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteTransaction()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l size-m",
                class: "mtop-01"
              }),
              _createVNode(_component_text_item, {
                txt: _unref(t)('action.delete'),
                styles: "main-l",
                class: "mleft-03"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('common.amount'),
      class: "mtop-15",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_3, [
      (__props.transaction.isLocked)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: props.transaction.amount,
            styles: "main-m"
          }, null, 8, ["txt"]))
        : (_openBlock(), _createBlock(_component_inputBox, {
            key: 1,
            style: {"width":"4rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                ref: "inputRef",
                modelValue: currAmount.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currAmount).value = $event)),
                onKeydown: _unref(gen).onlyNumber,
                onPaste: _unref(gen).onlyNumber,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isEdited.value = true))
              }, null, 8, ["modelValue", "onKeydown", "onPaste"])
            ]),
            _: 1
          })),
      _createVNode(_component_text_item, {
        txt: " €",
        styles: "main-m",
        class: "mleft-04"
      })
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('common.date'),
      class: "mtop-15",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    (__props.transaction.isLocked)
      ? (_openBlock(), _createBlock(_component_text_item, {
          key: 0,
          txt: _unref(apiDateString)(__props.transaction.transactionDateTime),
          styles: "main-m"
        }, null, 8, ["txt"]))
      : (_openBlock(), _createBlock(_component_inputNewDate, {
          key: 1,
          dateIso: __props.transaction.transactionDateTime,
          calendar: false,
          trash: false,
          onChanged: updateActDate,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (isEdited.value = true))
        }, null, 8, ["dateIso"])),
    _createVNode(_component_text_item, {
      txt: _unref(t)('accounting.paymentType'),
      class: "mtop-15",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_4, [
      (!showChannelSwitch.value)
        ? (_openBlock(), _createBlock(_component_text_item, {
            key: 0,
            txt: props.transaction.channelTitle,
            styles: "main-m",
            class: "mtop-03"
          }, null, 8, ["txt"]))
        : (_openBlock(), _createBlock(_component_dropdownBox, {
            key: 1,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
            openOn: "modifyPaymentType",
            class: "mtop-02"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", {
                class: "bg-modal",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_dbGroup, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(switchableChannels.value, (channel, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (props.transaction.financialChannelId !== channel.id)
                          ? (_openBlock(), _createBlock(_component_list_group, {
                              key: 0,
                              class: "w-full gap-04",
                              styles: "pad-s",
                              onClick: ($event: any) => (modifyTxChannel(channel))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(channel.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                theme: "dropdown",
                styles: "pad-s border-l",
                class: "psides-04 mtop-02"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: props.transaction.channelTitle
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
    ]),
    (isSubmitting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(loadingSpinner, {
            logo: false,
            style: 'w-3'
          })
        ]))
      : (isEdited.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_button_group, {
              styles: "border-h pad-s",
              class: "psides-10",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (update()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('action.validate'),
                  styles: "font-mBold"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }),
            _createVNode(_component_button_group, {
              styles: "border-h pad-s",
              class: "psides-10",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (cancel()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('action.cancel'),
                  styles: "font-mBold"
                }, null, 8, ["txt"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})